import { z } from 'zod'
import { useSyncedState } from './useSyncedState'

export function useValueTypeFilterState(): [string[], (next: string[]) => void] {
  const [raw, setRaw] = useSyncedState('value_types', z.string(), 'url', '')
  const value = raw ? raw.split(',').filter(Boolean) : []
  const setter = (next: string[]) => setRaw(next.join(','))
  return [value, setter]
}
